import { createStore } from 'vuex'

export default createStore({
  state: {
    episode_id:'',
    headimg:'',
    nickname:'',
  },
  getters: {
  },
  mutations: {
    setEpisodeId(state,episode_id){
      state.episode_id = episode_id      
    },
    editUser(state,userInfo){
      state.headimg = userInfo.headimg; 
      state.nickname = userInfo.nickname;
    }
  },
  actions: {
  },
  modules: {
  }
})
